import { render } from "./op_items.vue?vue&type=template&id=e75b0750"
import script from "./op_items.vue?vue&type=script&lang=js"
export * from "./op_items.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__